export const EXPORT_TOTALS_FETCHING = 'EXPORT_TOTALS_FETCHING';
export const EXPORT_TOTALS_FETCH_SUCCESS = 'EXPORT_TOTALS_FETCH_SUCCESS';
export const EXPORT_TOTALS_FETCH_ERROR = 'EXPORT_TOTALS_FETCH_ERROR';
export const EXPORT_TOTALS_CLEAR_ERRORS = 'EXPORT_TOTALS_CLEAR_ERRORS';
export const EXPORT_TOTALS_SET_HAS_REPORT = 'EXPORT_TOTALS_SET_HAS_REPORT';



// WEBPACK FOOTER //
// ./src/pages/exporttotals/state/types.js